import { render } from "./PaginationModel.vue?vue&type=template&id=670d9f9e"
import script from "./PaginationModel.vue?vue&type=script&lang=js"
export * from "./PaginationModel.vue?vue&type=script&lang=js"

import "./PaginationModel.vue?vue&type=style&index=0&id=670d9f9e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__